import { observable } from 'mobx';
import { copyPropertiesExcludeNullsAndGetters } from '../../utils/ObjectUtils';

export interface ICrossSell {
    sku_id: string;
    sort_key: number;
}

export interface ICrossSellData {
    skuId: string;
    sortKey: number;
}

export class CrossSell {
    @observable public skuId: string = '';
    @observable public sortKey: number;

    public static fromPlainObject(data: CrossSell): CrossSell {
        const newCrossSell = new CrossSell();
        copyPropertiesExcludeNullsAndGetters(newCrossSell, data);

        return newCrossSell;
    }

    public static fromJson(data: ICrossSell): CrossSell {
        const newCrossSell = new CrossSell();
        if (!data) {
            return newCrossSell;
        }

        const crossSellDataMapping = {
            skuId: data.sku_id,
            sortKey: data.sort_key
        };

        copyPropertiesExcludeNullsAndGetters(newCrossSell, crossSellDataMapping);

        return newCrossSell;
    }
}
